import React from 'react';
import { Link } from 'react-router-dom';

const AdditionalPageCard = ({ page }) => {
  const isDisabled = !!page.status;

  const baseClass =
    'bg-white text-current text-center flex flex-col gap-[15px] rounded-[20px] p-[30px] border-2 border-[#e8f0fe] transition-all duration-300 no-underline';
  const hoverClass = !isDisabled
    ? ' hover:-translate-y-[5px] hover:border-icetex cursor-pointer'
    : ' cursor-default';

  const content = (
    <>
      <div className="flex items-center justify-center w-[50px] h-[50px] bg-blue-50 rounded-full mx-auto mb-[15px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-icetex"
          style={{ width: '25px', height: '25px' }}
        >
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
        </svg>
      </div>
      <h3 className="text-texto-oscuro font-bold text-[1.2rem] mb-[10px]">{page.title}</h3>
      {page.status && (
        <span className="inline-block font-semibold bg-gray-200 text-gray-500 py-[5px] px-[15px] rounded-full text-[0.85rem]">
          {page.status}
        </span>
      )}
      {page.external && (
        <span className="inline-flex items-center text-icetex font-semibold bg-blue-50 px-3 py-[5px] rounded-full text-[0.8rem] gap-[5px] mx-auto">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ width: '12px', height: '12px' }}
          >
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
            <polyline points="15 3 21 3 21 9"></polyline>
            <line x1="10" y1="14" x2="21" y2="3"></line>
          </svg>
          Externo
        </span>
      )}
    </>
  );

  if (page.external) {
    return (
      <a
        href={page.path}
        target="_blank"
        rel="noopener noreferrer"
        className={baseClass + hoverClass}
        style={{ boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)' }}
      >
        {content}
      </a>
    );
  }

  if (!page.status) {
    return (
      <Link
        to={page.path}
        className={baseClass + hoverClass}
        style={{ boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)' }}
      >
        {content}
      </Link>
    );
  }

  return (
    <div
      className={baseClass + hoverClass}
      style={{ boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)' }}
    >
      {content}
    </div>
  );
};

const AdditionalPages = ({ pages }) => {
  return (
    <div className="mb-[60px]">
      <h2 className="text-texto-oscuro font-extrabold text-center text-[2rem] mb-4">
        Páginas Adicionales
      </h2>
      <p className="text-texto-sec text-center mx-auto text-[1.1rem] leading-[1.8] max-w-[700px] mb-[40px]">
        Accede a otras secciones importantes del portal y recursos complementarios.
      </p>
      <div
        className="grid mt-[30px]"
        style={{
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '25px',
        }}
      >
        {pages.map((page, index) => (
          <AdditionalPageCard key={index} page={page} />
        ))}
      </div>
    </div>
  );
};

export default AdditionalPages;
